@if (input.isRemovable()) {
  <div class="remove-button-wrapper">
    <rt-icon-button
      variant="plain"
      iconName="clear"
      shape="square"
      (click)="clickRemove()"
      class="danger-on-hover remove-button"
    />
  </div>
}

@if (!input.isHidden()) {
  <rt-form-field [required]="showRequiredAsterisk(input)" margin-bottom>
    @if (input.config.label) {
      <rt-label>
        {{ helpers.buildText(input.config.label) }}

        @if (input.config.helpTooltip) {
          <rt-icon-help
            [rtTooltip]="helpers.buildText(input.config.helpTooltip)"
            margin-left-small-x
          />
        }
      </rt-label>
    }

    @switch (input.type) {
      @case (DynamicInputConfigType.TEXT) {
        @if (isInput(input.config)) {
          <rt-input
            variant="rounded"
            [formControl]="input.control"
            [readOnly]="!!input.config.readOnly"
            [placeholder]="input.config.placeholder || ''"
            [rtFormError]="input.formError"
            (keyup.enter)="input.config.emitEventOnEnter && onEnter()"
          />
        }
      }

      @case (DynamicInputConfigType.EMAIL) {
        @if (isEmail(input.config)) {
          <rt-input
            variant="rounded"
            [formControl]="input.control"
            [placeholder]="input.config.placeholder || ''"
            [readOnly]="!!input.config.readOnly"
            (keyup.enter)="input.config.emitEventOnEnter && onEnter()"
          />
        }
      }

      @case (DynamicInputConfigType.CHECKBOX) {
        <rti-checkbox-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.SELECT) {
        <rti-dynamic-select-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.GENERATED_PASSWORD) {
        <rti-generated-password-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.FORM_LOADER) {
        <rti-form-loader-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.TYPEAHEAD) {
        <rti-dynamic-typeahead-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.CANDIDATE_EMAIL) {
        <rti-candidate-email-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.DATE_PICKER) {
        <rti-date-picker-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.DATE_DROPDOWNS) {
        <rti-date-dropdowns-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.TIME_PICKER) {
        <rti-time-picker-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.ADMINS) {
        <rti-admins-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.ADMIN_SELECT) {
        <rti-admin-select-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.CANDIDATE_PLACEMENT) {
        <rti-placement-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.RESOURCE_SELECT) {
        <rti-resource-select-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.COUNTRY_SELECT) {
        <rti-country-select-input [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.REGION_SELECT) {
        <rti-region-select-input [input]="$any(input)" />
      }
      @case (DynamicInputConfigType.SUBDOMAIN) {
        <rti-subdomain-input-adapter [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.PREPEND) {
        <rti-prepend-input-adapter [input]="$any(input)" />
      }

      @case (DynamicInputConfigType.CUSTOM) {
        <rti-custom-input [input]="$any(input)" />
      }
    }
  </rt-form-field>
}
